import { createFeatureActionNamer } from '../../../../../redux/action-name';
const getActionName = createFeatureActionNamer('funeral-form-details');
export const ADD_FUNERAL_CLAIMANT = getActionName('ADD_FUNERAL_CLAIMANT');
export const DELETE_FUNERAL_CLAIMANT = getActionName('DELETE_FUNERAL_CLAIMANT');
export const UPDATE_FUNERAL_CLAIMANT = getActionName('UPDATE_FUNERAL_CLAIMANT');
